<div class="modal-header">
  <div class="modal-title">
    <h3 class="mb-0">Select operating {{ plural }}</h3>
    <p class="modal-subtitle mb-0">
      Every {{ singular }} this vendor performs work in.
    </p>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>

<div class="modal-body">
  <div class="osm-toolbar">
    <input
      type="search"
      class="form-control"
      [placeholder]="'Search ' + plural"
      [attr.aria-label]="'Search ' + plural"
      [(ngModel)]="filterText"
    />
    <span class="osm-count" aria-live="polite">
      {{ selectedIds.size }} selected
      @if (selectedIds.size > 0) {
        ·
        <button type="button" class="osm-clear" (click)="clear()">Clear</button>
      }
    </span>
  </div>

  @if (visibleClientDivisions.length > 0) {
    <div class="osm-section" role="heading" aria-level="4">
      <i class="bi bi-shield-check"></i>
      Where this vendor's clients operate:
    </div>
    <div class="osm-grid">
      @for (division of visibleClientDivisions; track division.id) {
        <label class="osm-option">
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="selectedIds.has(division.id)"
            (change)="toggle(division)"
          />
          <span class="osm-option__text">
            {{ division.name }}
            <span class="osm-option__clients">
              {{ division.clientNames.join(', ') }}
            </span>
          </span>
        </label>
      }
    </div>
  }

  @if (visibleOtherDivisions.length > 0) {
    <div class="osm-section" role="heading" aria-level="4">
      {{ (visibleClientDivisions.length > 0 ? 'All other ' : 'All ') + plural }}
    </div>
    <div class="osm-grid">
      @for (division of visibleOtherDivisions; track division.id) {
        <label class="osm-option">
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="selectedIds.has(division.id)"
            (change)="toggle(division)"
          />
          <span class="osm-option__text">{{ division.name }}</span>
        </label>
      }
    </div>
  }

  @if (
    visibleClientDivisions.length === 0 && visibleOtherDivisions.length === 0
  ) {
    <p class="osm-empty">No {{ plural }} match "{{ filterText }}".</p>
  }
</div>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    <button type="button" class="btn btn-ghost" (click)="cancel()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary" (click)="done()">Done</button>
  </div>
</div>
